import Snowplow from 'constants/snowplow'

const SNOWPLOW_VISIT_COUNT_INDEX = 2
const SNOWPLOW_SESSION_ID_INDEX = 5
const SNOWPLOW_PREVIOUS_SESSION_INDEX = 6

function hasCookieValue(value: string | undefined): boolean {
  return !!value && value !== 'undefined' && value !== 'null'
}

function hasReturningVisitCount(value: string | undefined): boolean {
  const visitCount = Number(value)
  return Number.isInteger(visitCount) && visitCount > 1
}

function hasExpiredEarlierSession(idCookieName: string, parts: Array<string>, cookies: Record<string, string>): boolean {
  const domainHash = idCookieName.slice('_sp_id.'.length)
  const hasActiveSession = hasCookieValue(cookies[`_sp_ses.${domainHash}`])
  // Snowplow starts a new visit before hydration when this session cookie has expired.
  return hasCookieValue(parts[SNOWPLOW_SESSION_ID_INDEX]) && !hasActiveSession
}

/**
 * A device has prior activity when Snowplow has already recorded an earlier
 * visit. An active first session has visit count 1, no previous session id,
 * and a live session cookie. An expired first session still counts, because
 * the browser tracker turns it into visit 2 before hydration.
 */
export function hasPriorDeviceSession(cookies: Record<string, string>): boolean {
  if (hasReturningVisitCount(cookies[Snowplow.sessionIdxCookie])) return true

  return Object.entries(cookies).some(([key, value]) => {
    if (!key.startsWith('_sp_id.')) return false

    const parts = value.split('.')
    return hasReturningVisitCount(parts[SNOWPLOW_VISIT_COUNT_INDEX]) ||
      hasCookieValue(parts[SNOWPLOW_PREVIOUS_SESSION_INDEX]) ||
      hasExpiredEarlierSession(key, parts, cookies)
  })
}
